export const resolvePathAndQuery = (
  originalPath: string
): {
  query: Record<string, string>;
  originalFilePath: string;
} => {
  const [filePath, queryStr = ''] = originalPath.split('?');
  return {
    query: queryStr.split('&').reduce((prev, cur) => {
      const [key, value] = cur.split('=');
      return {
        ...prev,
        [key]: value ?? true,
      };
    }, {}),
    originalFilePath: filePath,
  };
};

const esReg = /.(mjs|mts|js|jsx|ts|tsx)$/;

export function isJsExt(path: string) {
  const { originalFilePath } = resolvePathAndQuery(path);
  if (esReg.test(originalFilePath)) {
    return true;
  }
  return false;
}

export function isJsLoader(loader?: string) {
  return loader === 'js' || loader === 'ts' || loader === 'tsx' || loader === 'jsx';
}
